import classNames from 'classnames';
import React from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import css from './breadcrumbs.module.scss';

const StructureBreadCrumbsUser = ({ breadCrumbsUsers, changeGridContent }) => {
    if (breadCrumbsUsers?.length) {
        return (
            <div className={css.breadCrumbsUsersWrapper}>
                <div className={css.breadCrumbsUsersWrap}>
                    {breadCrumbsUsers.map((val, idx) => (
                        <div key={`breadCrumbsUsers_${val}_${idx}`} className={classNames(css.breadCrumbsUsersItem)}>
                            <div
                                className={classNames(css.breadCrumbsUsersItemText, {
                                    [css.breadCrumbsUsersItemTextHover]: 1,
                                    [css.breadCrumbsUsersItemLast]: !breadCrumbsUsers[idx + 1]
                                })}
                                onClick={() => changeGridContent(val)}
                            >
                                {/* <p className={breadCrumbsUsers[idx + 1] ? css.breadCrumbsUsersItemTextP : ''}> */}
                                <p className={css.breadCrumbsUsersItemTextP}>
                                    {val.username?.username}
                                    <div>({val.username?.full_name})</div>
                                </p>
                            </div>
                            {idx !== breadCrumbsUsers.length - 1 && (
                                <div className={css.breadCrumbsUsersSlesh}>
                                    {svgSprite('angle-right-system', {
                                        width: '18px',
                                        height: '18px',
                                        fill: 'var(--gold700Color)'
                                    })}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};
export default StructureBreadCrumbsUser;
